import React from "react";
import Modal from "@/components/ui/modal";
import { Button } from "@/components/ui/button";
import { UserCog } from "lucide-react";
import { Spinner } from "@/components/ui/spinner";

export function ImpersonateModal({ open, onConfirm, onCancel, isLoading }) {
  return (
    <Modal
      open={open}
      onOpenChange={(v) => !v && !isLoading && onCancel()}
      title="Impersonate User"
      icon={UserCog}
      footer={
        <div className="flex justify-end gap-2 w-full">
          <Button variant="outline" onClick={onCancel} disabled={isLoading}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={isLoading}>
            {isLoading ? (
              <>
                <Spinner className="mr-2 h-4 w-4" />
                Switching…
              </>
            ) : (
              "Proceed"
            )}
          </Button>
        </div>
      }
    >
      <div className="space-y-4">
        <p className="text-sm text-muted-foreground">
          You are about to switch to another user's account. This will change
          your permissions and access level.
        </p>
        <div className="py-2 text-center">
          <p className="text-sm text-muted-foreground">
            Would you like to proceed with impersonating this user?
          </p>
        </div>
      </div>
    </Modal>
  );
}
